module.exports = __webpack_public_path__ + "static/header-image@2x-a78914bb560983b2b2db9b488a489241.png";